import { useRef } from 'react';
import styled from 'styled-components';
import { LazyProviderMenu } from 'calling-remote-common/components/ProviderMenu';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import ThirdPartyCallWrapper from 'calling-integration-remote-app/components/ThirdPartyCallWrapper';
import { useSetIframePosition } from '../hooks/useSetIframePosition';
import { FirstPartyCallRedesign } from './FirstPartyCallRedesign';
import { useResizeIframe } from 'calling-remote-common/hooks/useResizeIframe';
import { HeaderDragBar } from '../../common/components/HeaderDragBar';
import PhoneNumberContextProvider from 'calling-ui-library/calling-remote-redesign/contexts/PhoneNumberContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledContentWrapper = styled.div.withConfig({
  displayName: "CallWrapper__StyledContentWrapper",
  componentId: "sc-1djxrhb-0"
})(({
  isVisible
}) => `
  display: ${isVisible === 'hidden' ? 'none' : 'block'};
`);
const StyledWrapper = styled.div.withConfig({
  displayName: "CallWrapper__StyledWrapper",
  componentId: "sc-1djxrhb-1"
})(["display:inline-block;width:auto;"]);
export function CallWrapper(props) {
  const {
    iframeRightOffset = 0,
    iframeTopOffset = 0
  } = props;
  useSetIframePosition({
    iframeRightOffset,
    iframeTopOffset
  });
  const {
    isThirdPartyProviderSelected,
    showProviderMenu
  } = useSelectedProviderContext();
  const wrapperRef = useRef(null);
  useResizeIframe(wrapperRef);
  return /*#__PURE__*/_jsxs(StyledWrapper, {
    ref: wrapperRef,
    children: [/*#__PURE__*/_jsx(HeaderDragBar, {}), /*#__PURE__*/_jsxs(_Fragment, {
      children: [showProviderMenu && /*#__PURE__*/_jsx(LazyProviderMenu, Object.assign({}, props)), /*#__PURE__*/_jsx(StyledContentWrapper, {
        isVisible: showProviderMenu ? 'hidden' : 'visible',
        children: isThirdPartyProviderSelected ? /*#__PURE__*/_jsx(ThirdPartyCallWrapper, {}) : /*#__PURE__*/_jsx(PhoneNumberContextProvider, {
          children: /*#__PURE__*/_jsx(FirstPartyCallRedesign, Object.assign({}, props))
        })
      })]
    })]
  });
}